import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useRouter from '../hook/useRouter';
import { RootState } from '../store';

export const ResultWrapFavorite = () => {
    const l10n = useSelector((state: RootState) => state.main.l10n);

    const { params, getValue, changeParam } = useRouter(['favorite']);
    const [isFav, isFavSet] = useState(false);

    useEffect(() => {
        if (!params) return;
        const val = getValue('favorite');
        isFavSet(val === 'true' ? true : false);
    }, [params]);

    const onFavClick = () => {
        if (!isFav && window.isLoginFlag !== 'true') window.GNBLogin();

        changeParam({ favorite: (!isFav).toString(), page: '' });
        isFavSet(!isFav);
    };

    return (
        <button data-name="btn-favorite" data-areas="시세_리스트_즐겨찾기필터_클릭" onClick={onFavClick}>
            <i className={`ico-favorite ${isFav ? 'is-active' : ''}`}></i> {l10n['common.viewfavorites']}
        </button>
    );
};
